export class NetworkError extends Error {
  readonly type: string;
  constructor() {
    super('Network connection failed.');
    this.type = 'NetworkError';
  }
}

export const isNetworkError = (error: unknown): boolean => {
  return error instanceof NetworkError || (error instanceof TypeError && error.message === 'Failed to fetch');
};
